import { Component, OnInit, ViewChild } from '@angular/core';
import { OverviewModel } from '@app/core/Models';
import { OverviewState } from '@app/core/Store';
import { Select } from '@ngxs/store';

import {
  ApexAxisChartSeries,
  ApexChart,
  ApexDataLabels,
  ApexFill,
  ApexLegend,
  ApexNoData,
  ApexPlotOptions,
  ApexStroke,
  ApexTooltip,
  ApexXAxis,
  ApexYAxis,
  ChartComponent,
} from 'ng-apexcharts';
import { Observable } from 'rxjs';

export type FlowChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  yaxis: ApexYAxis;
  xaxis: ApexXAxis;
  fill: ApexFill;
  tooltip: ApexTooltip;
  stroke: ApexStroke;
  legend: ApexLegend;
  noData: ApexNoData;
};

@Component({
  selector: 'app-overview-flow-chart',
  templateUrl: './overview-flow-chart.component.html',
  styleUrls: ['./overview-flow-chart.component.scss'],
})
export class OverviewFlowChartComponent implements OnInit {
  @ViewChild('chart') chart: ChartComponent;

  public flowChartOptions: Partial<FlowChartOptions>;
  reportList: OverviewModel;

  @Select(OverviewState.overviewData)
  overviewData$: Observable<OverviewModel>;

  ngOnInit(): void {
    this.overviewData$.subscribe((data) => {
      this.reportList = data;
      if (Object.keys(this.reportList).length > 0) {
        this.getIncomeFlow();
      }
    });
  }

  getIncomeFlow(): void {
    const tempSeries: any = [];
    const tempCategories: any = [];

    for (const barchartData of this.reportList.barChart1['categories']) {
      tempCategories.push(barchartData);
    }

    for (const barchartData of this.reportList.barChart1[`series`]) {
      tempSeries.push(barchartData.data);
    }

    this.flowChartOptions = {
      series: [
        {
          name: 'Net Profit',
          data: tempSeries,
        },
      ],
      chart: {
        type: 'bar',
        height: 350,
        toolbar: {
          show: false,
        },
      },
      noData: {
        text: 'No Data to Display',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
          color: '#6d41a1',
          fontSize: '18px',
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '55%',
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ['transparent'],
      },
      tooltip: {
        marker: {
          show: false,
        },
        enabled: true,
        fillSeriesColor: false,
      },
      xaxis: {
        categories: tempCategories,
      },
      fill: {
        opacity: 1,
        type: 'gradient',
        colors: ['#9966D4'],
        gradient: {
          shade: 'light',
          type: 'vertical',
          shadeIntensity: 0.5,
          gradientToColors: ['#F3ACC4'],
          inverseColors: true,
          opacityFrom: 1,
          opacityTo: 1,
          stops: [0, 100, 100, 100],
        },
      },
    };
  }
}
